import React, { Component } from 'react';
import Row from '../Row';
import Col from '../Col';
import FontAwesomeIcon from '../Icon';
import Checkbox from '../Checkbox';
import classNames from 'classnames';
import SignaturePad from 'react-signature-canvas';
import './SignatureCanvas.scss';

import { Images } from '../../Tenants';

import { BrandingContext } from '../../branding/BrandingContextProvider';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { ROLES } from 'src/utils/MessagingUtils/shared-constants';
import { connect } from 'react-redux';

class SignatureCanvas extends Component {
  state = {
    trimmedDataURL: null,
    signType: 1,
    signText: '',
    acceptTermsConditions: false,
  };
  sigPad = {};
  clear = () => {
    const { signType } = this.state;
    if (signType === 1) {
      this.sigPad.clear();
      this.setState({ trimmedDataURL: null });
    } else if (signType === 2) {
    } else if (signType === 3) {
      this.setState({ signText: '' });
    }
  };
  trim = () => {
    const { onInsert } = this.props;
    let { signType, signText, trimmedDataURL } = this.state;
    if (signType === 1) {
      this.setState(
        {
          trimmedDataURL: this.sigPad.getTrimmedCanvas().toDataURL('image/png'),
        },
        () => onInsert(trimmedDataURL, 'signed')
      );
    } else if (signType === 2) {
    } else if (signType === 3) {
      onInsert(signText, 'text');
    }
  };

  renderSignSelectedType() {
    let { signType } = this.state;
    const { signed } = this.props;

    if (signed !== '') {
      signType = this.props.signType;
      if (signType === 'text') {
        return (
          <div className="signatureCanvas__signText">
            <input
              value={signed}
              className="signatureCanvas__signText__FontStyle"
              type="text"
              disabled
            />
          </div>
        );
      } else if (signType === 'signed') {
        return (
          <div
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              height: '125% !important',
              width: '80%',
              padding: 5,
            }}
          >
            <img
              alt=""
              src={signed}
              style={{
                minWidth: '1%',
                maxWidth: '70%',
                minHeight: '1%',
                maxHeight: '80%',
                padding: 5,
              }}
            />
          </div>
        );
      }
    } else {
      if (signType === 1) {
        return (
          <SignaturePad
            canvasProps={{ className: 'signatureCanvas__sigPad' }}
            ref={(ref) => {
              this.sigPad = ref;
            }}
            onEnd={() =>
              this.setState({
                trimmedDataURL: this.sigPad
                  .getTrimmedCanvas()
                  .toDataURL('image/png'),
              })
            }
          />
        );
      } else if (signType === 2) {
        return null;
      } else if (signType === 3) {
        return (
          <>
            <div className="signatureCanvas__signText">
              <input
                value={this.state.signText}
                className="signatureCanvas__signText__FontStyle"
                type="text"
                onChange={(e) => this.setState({ signText: e.target.value })}
              />
            </div>
          </>
        );
      }
    }
  }
  buttonStatus() {
    let { trimmedDataURL, signText, signType } = this.state;
    if (signType === 1) {
      if (trimmedDataURL === null) {
        return true;
      } else {
        return false;
      }
    } else if (signType === 2) {
      return true;
    } else if (signType === 3) {
      if (signText === '') {
        return true;
      } else {
        return false;
      }
    }
  }
  removeSign() {
    const { remove } = this.props;
    this.setState({
      trimmedDataURL: null,
      signType: 1,
      signText: '',
      acceptTermsConditions: false,
    });
    remove();
  }
  static contextType = BrandingContext;
  render() {
    let { signType, acceptTermsConditions } = this.state;
    const {
      onClose,
      signed,
      firstName,
      lastName,
      type,
      typeOfSign,
      permissions,
      user,
      signeeRole
    } = this.props;
    let edit = signed === '' ? true : false;


    let confirmationText = '';
    if (
      typeOfSign === 'Home Owner Walk-through' ||
      ((typeOfSign === 'Simplified' || typeOfSign === 'Enhanced') &&
        permissions === 'Homeowner or Occupant')
    ) {
      confirmationText =
        Images.completeHomeOwnerWalkThroughSignatureTermsAndConditions;
    } else {
      confirmationText = Images.completeWalkThroughSignatureTermsAndConditions;
    }

    const { branding } = this.context;
    if (type === 'keyhandoff') {
      if (signeeRole === ROLES.PROPERTY_DEVELOPER) {
        confirmationText =
          branding?.text?.propertyDeveloperKeyPickupConfirmation;
      } else {
        confirmationText = branding?.text?.keyPickupConfirmation;
      }
    }

    return (
      <div className="signatureCanvas">
        <Row mdCenter>
          <Col>
            <div className="signatureCanvas__options">
              <div
                className={classNames('signatureCanvas__options__option', {
                  signatureCanvas__options__option__signSelected:
                    signType === 1,
                })}
                onClick={() => (edit ? this.setState({ signType: 1 }) : null)}
              >
                <FontAwesomeIcon glyph="signature" weight="solid" />
              </div>
              <div
                className={classNames('signatureCanvas__options__option', {
                  signatureCanvas__options__option__signSelected:
                    signType === 3,
                })}
                onClick={() =>
                  edit
                    ? this.setState({
                        signType: 3,
                        signText: firstName + ' ' + lastName,
                      })
                    : null
                }
              >
                <FontAwesomeIcon glyph="text" weight="regular" />
              </div>
            </div>
          </Col>
          <Col xs="10" md="10">
            <div className="signatureCanvas__container">
              <div style={{ textAlign: 'right' }}>
                <button
                  className="signatureCanvas__buttons"
                  onClick={() => (edit ? this.clear() : this.removeSign())}
                >
                  {edit ? 'Clear' : 'Remove'}
                </button>
              </div>
              <div className="signatureCanvas__sigContainer">
                {this.renderSignSelectedType()}
              </div>
            </div>
          </Col>
          <div className="signatureCanvas__insertBox">
            <div style={{ display: 'flex', width: '90%' }}>
              <div
                className="signatureCanvas__insertBox__backButton"
                onClick={() => (edit ? (onClose ? onClose() : null) : null)}
              >
                <div style={{ paddingTop: 0.5, paddingRight: 5 }}>
                  <FontAwesomeIcon
                    glyph="chevron-left"
                    weight="solid"
                    size="small"
                  />
                </div>
                Back
              </div>
              <div className="signatureCanvas__insertBox__legalNote">
                I understand this is a legal representation of my signature
              </div>
            </div>
            <div className="signatureCanvas__insertBox__InsertButton">
              <div
                className={classNames(
                  'signatureCanvas__insertBox__InsertButton__button',
                  {
                    signatureCanvas__insertBox__InsertButton__button__disabled:
                      this.buttonStatus(),
                  }
                )}
                onClick={() =>
                  edit
                    ? acceptTermsConditions === true
                      ? this.trim()
                      : alert('Please check terms and condition check box')
                    : null
                }
              >
                {edit ? 'INSERT' : 'Added'}
              </div>
            </div>
          </div>
          <div style={{ fontSize: 20, padding: 20, paddingBottom: '5em' }}>
            <Checkbox
              label={confirmationText}
              value={signed !== '' ? true : acceptTermsConditions}
              onChange={(e) =>
                edit
                  ? this.setState({
                      acceptTermsConditions: !acceptTermsConditions,
                    })
                  : null
              }
            />
          </div>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: selectAuthenticatedUser(state),
});
export default connect(mapStateToProps)(SignatureCanvas);
